<template>
  <v-card title="休假查询">
    <div class="grid-demo">
      <v-form slot="form">
        <v-row :gutter="24">
          <v-col class="gutter-row" span="24">
            <div style="text-align: left">
              <v-form-item>
                <vxe-input
                  size="mini"
                  v-model="xjrqq"
                  placeholder="休假日期起"
                  type="date"
                  valueFormat="yyyy-MM-dd"
                ></vxe-input>
              </v-form-item>
              <v-form-item>
                <vxe-input
                  size="mini"
                  v-model="xjrqz"
                  placeholder="休假日期止"
                  type="date"
                  valueFormat="yyyy-MM-dd"
                ></vxe-input>
              </v-form-item>
              <v-form-item>
                <v-input placeholder="输入工号或姓名" v-model="cx"></v-input>
              </v-form-item>
              <v-form-item>
                <vxe-select
                  v-model="khbh"
                  size="mini"
                  placeholder="请选择客户"
                  :options="khbh_options"
                  clearable
                  @change="xz_khbh"
                ></vxe-select>
              </v-form-item>
              <v-form-item>
                <v-tree-select
                  @check="onCheck"
                  @clear="onClear"
                  style="padding-top: 2px; width: 200px"
                  :data="treeData2"
                  placeholder="请选择地区"
                  allow-clear
                  multiple
                ></v-tree-select>
              </v-form-item>
              <v-form-item>
                <vxe-select
                  v-model="fz"
                  size="mini"
                  placeholder="请选择组别"
                  :options="fz_options"
                  clearable
                ></vxe-select>
              </v-form-item>
              <v-form-item>
                <v-button type="primary" icon="search" @click="findList()"
                  ><span>检索</span></v-button
                >
              </v-form-item>
              <v-form-item>
                <v-button type="warning" icon="export" @click="exportExcel()"
                  ><span>导出</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <br />
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :data="tableData"
    >
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
  </v-card>
</template>
<script>
let options = {
  id: "",
};
export default {
  data() {
    return {
      options,
      tableData: [],
      khbh_options: [],
      fz_options:[],
      cx: "",
      xjrqq: "",
      xjrqz: "",
      khbh: "",
      dq: [],
      fz:"",
      treeData2: [],
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: 408,
        headerAlign: "center",
        checkboxConfig: {
          labelField: "id",
          highlight: true,
          range: true,
        },
        editConfig: {
          trigger: "", //click可以编辑表格
          mode: "row",
          showStatus: true,
        },
        columns: [
          {
            type: "seq",
            title: "序号",
            width: 70,
            align: "center",
          },
          {
            field: "gh",
            title: "工号",
            align: "center",
          },
          {
            field: "xm",
            title: "姓名",
            align: "center",
          },
          {
            field: "khbh",
            title: "客户编号",
            align: "center",
          },
          {
            field: "khmc",
            title: "客户名称",
            align: "center",
          },
          {
            field: "xjlx_mc",
            title: "休假类型",
            align: "center",
          },
          {
            field: "xjrq",
            title: "休假日期",
            align: "center",
          },
          {
            field: "xjz",
            title: "休假时长(小时)",
            headerAlign: "center",
            align: "right",
          },
        ],
      },
    };
  },
  created() {
    this.init_khbh();
    //this.init_dq();
    this.findList();
  },
  methods: {
    findList() {
      if (this.xjrqq != "" || this.xjrqz != "") {
        if (
          parseInt(this.xjrqq.replace(/-/g, "")) >
          parseInt(this.xjrqz.replace(/-/g, ""))
        ) {
          alert("请正确选择休假日期");
          return;
        }
      }
      this.$axios
        .get(
          "api/system/xjcx/get-xjcx-list?cx=" +
            this.cx +
            "&xjrqq=" +
            this.xjrqq +
            "&xjrqz=" +
            this.xjrqz +
            "&khbh=" +
            this.khbh +
            "&dq=" +
            this.dq+
            "&fz="+this.fz
        )
        .then((res) => {
          this.tableData = res.data.data;
        });
    },
    init_khbh: function () {
      this.$axios.get("api/system/rywh/get-rywh-khbh").then((res) => {
        let self = this;
        self.khbh_options = res.data.map((item) => {
          return { value: item.khbh, label: item.khjc };
        });
      });
    },
    xz_khbh: function () {
      this.init_dq();
    },
    init_dq: function () {
      this.$axios
        .get("api/system/xjcx/get-xjcx-dq?khbh=" + this.khbh)
        .then((res) => {
          let self = this;
          if (res.data.code == 200) {
            let self = this;
            self.treeData2 = res.data.data;
          } else {
            this.$message["error"](res.data.message);
          }
        });
    },
    init_fz: function () {
      this.$axios
        .get("api/system/xjcx/get-xjcx-fz?khbh=" + this.khbh + "&khdq=" + this.dq)
        .then((res) => {
          let self = this;
          self.fz_options = res.data.data.map((item) => {debugger;
            return { value: item.fzmc, label: item.fzmc };
          });
        });
    },
    exportExcel() {
      let a = document.createElement("a");
      a.href =
        "api/system/xjcx/休假统计?cx=" +
        this.cx +
        "&xjrqq=" +
        this.xjrqq +
        "&xjrqz=" +
        this.xjrqz +
        "&khbh=" +
        this.khbh +
        "&dq=" +
        this.dq+
        "&fz="+this.fz;
      a.click();
    },
    onCheck(data) {
      this.dq = [];
      for (var i = 0; i < data.length; i++) {
        this.dq.push(data[i].id);
      }
      // this.dq = [];
      // for (var i = 0; i < data.length; i++) {
      //   if (data[i].children) {
      //     for (var j = 0; j < data[i].children.length; j++) {
      //       this.dq.push(data[i].children[j].id);
      //     }
      //   }
      // }
      this.init_fz();
      console.log(this.dq);
    },
    onClear(data) {
      this.dq = [];
      this.fz = "";
      console.log("clear", this.dq);
    },
    destroyed() {
      window.removeEventListener("scroll", this.handleScroll);
    },
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/kqgl/xjcx.vue